import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable()
export class ToastService {

  constructor(private messageService: MessageService) {
  }

  addToastWithAction(message: string, actionLabel: string, action: () => void) {
    this.messageService.add({
      severity: 'success',
      life: 5000,
      data: {
        message: message,
        actionLabel: actionLabel,
        action: action
      }
    });
  }

  addToastWithMessage(message: string) {
    this.messageService.add({
      severity: 'success',
      life: 5000,
      data: {
        message: message
      }
    });
  }

  /**
   * Fehler-Toast. Formgleich zu addToastWithMessage, aber mit severity 'error' — das globale
   * Toast-Template (app.component.html) rendert kein Severity-Icon, der Unterschied entsteht
   * ausschliesslich ueber die .p-toast-message-error-Regel in styles.scss (#735).
   */
  addErrorToast(message: string) {
    this.messageService.add({
      severity: 'error',
      life: 5000,
      data: {
        message: message
      }
    });
  }

}
